<div class="etikett-dialog">
  <div class="etikett-dialog__form">
    <nz-spin [nzSpinning]="loading">
      <form nz-form [formGroup]="form" (ngSubmit)="submitForm()">
        @if (isFremdmarkeNutrition) {
          <nz-form-item>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="name">
              <span>Titel</span>
            </nz-form-label>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <input nz-input id="name" formControlName="name" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-control [nzSm]="8" [nzXs]="24"></nz-form-control>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <label nz-checkbox formControlName="printNutrition">Nährwerte anzeigen</label>
            </nz-form-control>
          </nz-form-item>

          @if (form.controls['printNutrition'].value) {
          <div class="nutrition-grid">
            <nz-form-item>
              <nz-form-label nzFor="energyKj">Energie (kJ)</nz-form-label>
              <nz-form-control>
                <nz-input-number id="energyKj" formControlName="energyKj" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="2" class="full-width"></nz-input-number>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label nzFor="energyKcal">Energie (kcal)</nz-form-label>
              <nz-form-control>
                <nz-input-number id="energyKcal" formControlName="energyKcal" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="2" class="full-width"></nz-input-number>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label nzFor="fat">Fett (g)</nz-form-label>
              <nz-form-control>
                <nz-input-number id="fat" formControlName="fat" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="2" class="full-width"></nz-input-number>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label nzFor="saturatedFat">davon gesättigte Fettsäuren (g)</nz-form-label>
              <nz-form-control>
                <nz-input-number id="saturatedFat" formControlName="saturatedFat" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="2" class="full-width"></nz-input-number>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label nzFor="carbohydrates">Kohlenhydrate (g)</nz-form-label>
              <nz-form-control>
                <nz-input-number id="carbohydrates" formControlName="carbohydrates" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="2" class="full-width"></nz-input-number>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label nzFor="sugar">davon Zucker (g)</nz-form-label>
              <nz-form-control>
                <nz-input-number id="sugar" formControlName="sugar" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="2" class="full-width"></nz-input-number>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label nzFor="protein">Eiweiß (g)</nz-form-label>
              <nz-form-control>
                <nz-input-number id="protein" formControlName="protein" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="2" class="full-width"></nz-input-number>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label nzFor="salt">Salz (g)</nz-form-label>
              <nz-form-control>
                <nz-input-number id="salt" formControlName="salt" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="2" class="full-width"></nz-input-number>
              </nz-form-control>
            </nz-form-item>
          </div>
          }

          <nz-form-item>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="storageNote">
              <span>Lager- und Verwendungshinweis</span>
            </nz-form-label>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <textarea nz-input id="storageNote" formControlName="storageNote" rows="2"></textarea>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item class="rich-text-form-item">
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="ingredients">
              <span>Zutaten</span>
            </nz-form-label>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <div class="angular-editor-custom-toolbar">
                <nz-form-item style="margin-bottom: 0;">
                  <nz-form-label>
                    <span>Zeilenhöhe</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="6">
                    <span class="d-flex align-items-center">
                      <input nz-input type="number" formControlName="lineHeight" />
                      &nbsp;mm
                    </span>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <app-rich-text-editor
                id="ingredients"
                placeholder=""
                [toolbarHiddenButtons]="toolbarHiddenButtons"
                formControlName="ingredients"
                height="80px"
              ></app-rich-text-editor>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-control [nzSm]="8" [nzXs]="24"></nz-form-control>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <label nz-checkbox formControlName="allIngredientsAreBio">Alle Zutaten sind bio</label>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="originLine">
              <span>Ursprungsland / Hinweis</span>
            </nz-form-label>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <input nz-input id="originLine" formControlName="originLine" placeholder="Ursprungsland Frankreich">
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="charge">
              <span>Charge</span>
            </nz-form-label>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <input nz-input id="charge" formControlName="charge">
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-control [nzSm]="8" [nzXs]="24"></nz-form-control>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <label nz-checkbox formControlName="printMhd">MHD drucken</label>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="fremdmarkeMhd">
              <span>MHD</span>
            </nz-form-label>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <nz-date-picker
                style="width: 100%;"
                [nzFormat]="dateFormat"
                id="fremdmarkeMhd"
                formControlName="mhd"
              ></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        }

        @if ((editObject?.type ?? labelType) === articleLabelTypes.Round50x25) {
          <nz-form-item>
            <nz-form-control [nzSm]="8" [nzXs]="24"></nz-form-control>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <label nz-checkbox formControlName="showIngredients">Zutaten anzeigen</label>
            </nz-form-control>
          </nz-form-item>
        }

        @if ((editObject?.type ?? labelType) === articleLabelTypes.Round50x50) {
          <nz-form-item>
            <nz-form-control [nzSm]="8" [nzXs]="24"></nz-form-control>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <label nz-checkbox formControlName="showNutrients">Nährwerte anzeigen</label>
            </nz-form-control>
          </nz-form-item>
        }

        @if (((editObject?.type ?? labelType) === articleLabelTypes.Round50x25 && !form.controls['showIngredients'].value) && (editObject?.type ?? labelType) !== articleLabelTypes.Round50x50) {
          <nz-form-item
            class="rich-text-form-item"
            >
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="content">
              <span>Inhalt</span>
            </nz-form-label>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <app-rich-text-editor
                id="content"
                placeholder=""
                [toolbarHiddenButtons]="toolbarHiddenButtons"
                formControlName="content"
                height="80px"
              ></app-rich-text-editor>
            </nz-form-control>
          </nz-form-item>
        }

        @if ((editObject?.type ?? labelType) === articleLabelTypes.Round50x50 && form.controls['showNutrients'].value) {
          <nz-form-item
            class="rich-text-form-item"
            >
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="content">
              <span>Nährwerte pro 100 g</span>
            </nz-form-label>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <app-rich-text-editor
                id="content"
                placeholder=""
                [toolbarHiddenButtons]="toolbarHiddenButtons"
                formControlName="content"
                height="80px"
              ></app-rich-text-editor>
            </nz-form-control>
          </nz-form-item>
        }

        @if (((editObject?.type ?? labelType) === articleLabelTypes.Round50x25 && form.controls['showIngredients'].value) || (editObject?.type ?? labelType) === articleLabelTypes.Round58x58 || (editObject?.type ?? labelType) === articleLabelTypes.Round50x50) {
          <nz-form-item
            class="rich-text-form-item"
            >
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="ingredients">
              <span>Zutaten</span>
            </nz-form-label>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <app-rich-text-editor
                id="ingredients"
                placeholder=""
                [toolbarHiddenButtons]="toolbarHiddenButtons"
                formControlName="ingredients"
                height="80px"
              ></app-rich-text-editor>
            </nz-form-control>
          </nz-form-item>
        }

        @if (!isFremdmarkeNutrition) {
          <nz-form-item>
            <nz-form-control [nzSm]="8" [nzXs]="24"></nz-form-control>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <label nz-checkbox formControlName="allIngredientsAreBio">Alle Zutaten sind bio</label>
            </nz-form-control>
          </nz-form-item>
        }

        @if ((editObject?.type ?? labelType) === articleLabelTypes.Round50x25 || (editObject?.type ?? labelType) === articleLabelTypes.Round50x50) {
          <nz-form-item>
            <nz-form-control [nzSm]="8" [nzXs]="24"></nz-form-control>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <label nz-checkbox formControlName="addBarCode">Barcode anzeigen</label>
            </nz-form-control>
          </nz-form-item>
        }

        @if (isRound50x25 && !form.controls['addBarCode'].value) {
          <nz-form-item>
            <nz-form-control [nzSm]="8" [nzXs]="24"></nz-form-control>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <label nz-checkbox formControlName="printMhd">MHD drucken</label>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="mhd">
              <span>MHD</span>
            </nz-form-label>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <nz-date-picker
                style="width: 100%;"
                [nzFormat]="dateFormat"
                id="mhd"
                formControlName="mhd"
              ></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="charge">
              <span>Charge</span>
            </nz-form-label>
            <nz-form-control [nzSm]="16" [nzXs]="24">
              <input nz-input id="charge" formControlName="charge">
            </nz-form-control>
          </nz-form-item>
        }
      </form>
    </nz-spin>
  </div>
  <div class="etikett-dialog__preview">
    <app-label-preview-host [preview]="preview" [loading]="previewLoading"></app-label-preview-host>
  </div>
</div>
